import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useHistory } from 'react-router-dom';
import makeStyles from '@material-ui/core/styles/makeStyles';
import MuiButton from '@material-ui/core/Button';

const useStyles = makeStyles({
  root: {
    fontSize: '0.75rem'
  }
});

const Button = ({
  route,
  disabled = false,
  size = 'medium',
  endIcon,
  children,
  classes = {}
}) => {
  const history = useHistory();
  const localClasses = useStyles();
  const allClasses = {
    ...localClasses,
    ...classes,
    root: cx(localClasses.root, classes.root)
  };

  const handleClick = () => {
    history.push(route);
  };

  return (
    <MuiButton
      variant="outlined"
      color="primary"
      onClick={handleClick}
      disabled={disabled}
      size={size}
      classes={allClasses}
      endIcon={endIcon}
    >
      {children}
    </MuiButton>
  );
};

Button.propTypes = {
  route: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  endIcon: PropTypes.node,
  children: PropTypes.object.isRequired,
  classes: PropTypes.object
};

export default Button;
